import { Link } from "react-router-dom";
import { Wrench, Settings, Smartphone, Wifi, ArrowRight } from "lucide-react";

const ServicesOverview = () => {
  const services = [
    {
      icon: Wrench,
      title: "Repairs",
      description: "Fast fixes for stuck, noisy, or damaged doors",
      link: "/repairs",
    },
    {
      icon: Settings,
      title: "Servicing",
      description: "Regular maintenance to keep your door running smoothly",
      link: "/servicing",
    },
    {
      icon: Smartphone,
      title: "Automation",
      description: "Smart upgrades for effortless, secure access",
      link: "/automation",
    },
    {
      icon: Wifi,
      title: "Smart Controllers",
      description: "Add app control to your existing garage door opener",
      link: "/smart-controller",
    },
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground mb-3">Our Services</h2>
          <p className="text-muted-foreground max-w-xl mx-auto">Everything you need for a safe, reliable, and modern garage door</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="group relative flex flex-col items-center text-center p-8 rounded-2xl bg-background border border-border hover:border-accent/50 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 rounded-2xl bg-accent/10 flex items-center justify-center mb-5 group-hover:bg-accent group-hover:scale-110 transition-all duration-300">
                <service.icon className="w-8 h-8 text-accent group-hover:text-accent-foreground transition-colors" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-2">{service.title}</h3>
              <p className="text-muted-foreground text-sm mb-4">{service.description}</p>
              <span className="inline-flex items-center gap-1 text-accent text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                Learn more <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
